
import React from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTheme } from "@/components/theme-provider";

interface ChatWidgetInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onSend: () => void;
  isLoading: boolean;
}

export function ChatWidgetInput({ 
  value, 
  onChange, 
  onKeyDown, 
  onSend, 
  isLoading 
}: ChatWidgetInputProps) {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  
  return (
    <div className="border-t p-3 bg-background">
      <div className="flex items-center gap-2">
        <Input
          placeholder="Scrivi un messaggio..."
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          disabled={isLoading}
          className="flex-1 bg-background text-foreground"
        />
        <Button 
          onClick={onSend} 
          disabled={!value.trim() || isLoading}
          size="icon"
          className="h-8 w-8 bg-metal-primary hover:bg-metal-dark"
        >
          <Send className={`h-4 w-4 ${isDarkMode ? "text-white" : "text-[color:var(--solid-metal-primary)]"}`} />
        </Button>
      </div>
    </div>
  );
}
